import { StyledCircle } from './Circle.styles'

const Circle: React.FC = (): JSX.Element => {
    return <StyledCircle />
}

export default Circle
